import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import PageTracker from "@/components/PageTracker";
import CanonicalHandler from "@/components/CanonicalHandler";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Programme from "@/pages/Programme";
import Correspondance from "@/pages/Correspondance";
import Subscription, { SubscriptionSuccess } from "@/pages/Subscription";
import ManageSubscription from "@/pages/ManageSubscription";
import Ateliers from "@/pages/Ateliers";
import MailClub from "@/pages/MailClub";
import MailClubInscription from "@/pages/MailClubInscription";
import MailClubMerci from "@/pages/MailClubMerci";
import MailClubGift from "@/pages/MailClubGift";
import ClubCancel from "@/pages/ClubCancel";
import AdminClubShipments from "@/pages/AdminClubShipments";
import Accompagnement from "@/pages/Accompagnement";
import { FEATURE_ACCOMPAGNEMENT, FEATURE_CORRESPONDANCE } from "@/config/features";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import { LegalMentions, CGV, Privacy } from "@/pages/Legal";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import GiftCard from "@/pages/GiftCard";
import { GiftCardSuccess, GiftCardPrint } from "@/pages/GiftCardExtras";
import Espace, { EspaceDashboard } from "@/pages/Espace";
import Journal, { JournalArticle } from "@/pages/Journal";
import AdminLogin from "@/pages/AdminLogin";
import AdminForgotPassword from "@/pages/AdminForgotPassword";
import AdminResetPassword from "@/pages/AdminResetPassword";
import AdminLayout from "@/pages/AdminLayout";
import AdminImport from "@/pages/AdminImport";
import AdminProgrammeTracking from "@/pages/AdminProgrammeTracking";
import AdminMailClub from "@/pages/AdminMailClub";
import AdminClient from "@/pages/AdminClient";
import AdminSystem from "@/pages/AdminSystem";
import AdminClubAudit from "@/pages/AdminClubAudit";
import ClubGiftCard from "@/pages/ClubGiftCard";
import AdminLabels from "@/pages/AdminLabels";
import {
  AdminCorrespondances, AdminCoffrets, AdminCodes, AdminGiftCards, AdminSubscriptions,
  AdminPromoCodes, AdminProgrammeEmails, AdminOrders, AdminInvoices,
  AdminEmails, AdminPages, AdminSettings,
} from "@/pages/Admin";
import { AdminSocial, AdminTestimonials, AdminLeads } from "@/pages/AdminExtras";
import { AdminContacts, AdminStats } from "@/pages/AdminAnalytics";
import { AdminNewsletterSend } from "@/pages/AdminNewsletter";

export default function App() {
  return (
    <BrowserRouter>
      <PageTracker/>
      <CanonicalHandler/>
      <Routes>
        <Route element={<PublicLayout/>}>
          <Route path="/" element={<Home/>}/>
          <Route path="/programme" element={<Programme/>}/>
          <Route path="/correspondance" element={FEATURE_CORRESPONDANCE ? <Correspondance/> : <Navigate to="/" replace/>}/>
          <Route path="/abonnement" element={<Navigate to={FEATURE_CORRESPONDANCE ? "/correspondance" : "/"} replace/>}/>
          <Route path="/abonnement/succes" element={FEATURE_CORRESPONDANCE ? <SubscriptionSuccess/> : <Navigate to="/" replace/>}/>
          <Route path="/mon-abonnement" element={<ManageSubscription/>}/>
          <Route path="/atelier" element={<Ateliers/>}/>
          <Route path="/ateliers" element={<Ateliers/>}/>
          <Route path="/club-de-lettres" element={<MailClub/>}/>
          <Route path="/club-de-lettres/inscription" element={<MailClubInscription/>}/>
          <Route path="/club-de-lettres/merci" element={<MailClubMerci/>}/>
          <Route path="/club-de-lettres/offrir" element={<MailClubGift/>}/>
          <Route path="/club-de-lettres/offrir/carte/:token" element={<ClubGiftCard/>}/>
          <Route path="/club-de-lettres/resilier" element={<ClubCancel/>}/>
          <Route path="/mail-club" element={<Navigate to="/club-de-lettres" replace/>}/>
          <Route path="/club-de-lettres/inscription" element={<Navigate to="/club-de-lettres/inscription" replace/>}/>
          <Route path="/mail-club/merci" element={<MailClubMerci/>}/>
          <Route path="/mail-club/offrir" element={<Navigate to="/club-de-lettres/offrir" replace/>}/>
          <Route path="/accompagnement" element={FEATURE_ACCOMPAGNEMENT ? <Accompagnement/> : <Navigate to="/" replace/>}/>
          <Route path="/carte-cadeau" element={<GiftCard/>}/>
          <Route path="/carte-cadeau/succes" element={<GiftCardSuccess/>}/>
          <Route path="/espace" element={<Espace/>}/>
          <Route path="/espace/verify" element={<EspaceDashboard/>}/>
          <Route path="/a-propos" element={<About/>}/>
          <Route path="/faq" element={<FAQ/>}/>
          <Route path="/journal" element={<Journal/>}/>
          <Route path="/journal/:slug" element={<JournalArticle/>}/>
          <Route path="/contact" element={<Contact/>}/>
          <Route path="/mentions-legales" element={<LegalMentions/>}/>
          <Route path="/cgv" element={<CGV/>}/>
          <Route path="/confidentialite" element={<Privacy/>}/>
          <Route path="/payment/success" element={<PaymentSuccess/>}/>
          <Route path="/payment/cancel" element={<PaymentCancel/>}/>
        </Route>
        <Route path="/carte-cadeau/print/:code" element={<GiftCardPrint/>}/>
        <Route path="/admin/login" element={<AdminLogin/>}/>
        <Route path="/admin/forgot-password" element={<AdminForgotPassword/>}/>
        <Route path="/admin/reset-password" element={<AdminResetPassword/>}/>
        <Route path="/admin" element={<ProtectedRoute><AdminLayout/></ProtectedRoute>}>
          <Route index element={<AdminCorrespondances/>}/>
          <Route path="coffrets" element={<AdminCoffrets/>}/>
          <Route path="codes" element={<AdminCodes/>}/>
          <Route path="gift-cards" element={<AdminGiftCards/>}/>
          <Route path="subscriptions" element={<AdminSubscriptions/>}/>
          <Route path="promo-codes" element={<AdminPromoCodes/>}/>
          <Route path="programme-emails" element={<AdminProgrammeEmails/>}/>
          <Route path="import" element={<AdminImport/>}/>
          <Route path="programme-tracking" element={<AdminProgrammeTracking/>}/>
          <Route path="mailclub" element={<AdminMailClub/>}/>
          <Route path="courriers" element={<AdminClubShipments/>}/>
          <Route path="clients/:email" element={<AdminClient/>}/>
          <Route path="systeme" element={<AdminSystem/>}/>
          <Route path="club-tests" element={<AdminClubAudit/>}/>
          <Route path="etiquettes" element={<AdminLabels/>}/>
          <Route path="orders" element={<AdminOrders/>}/>
          <Route path="invoices" element={<AdminInvoices/>}/>
          <Route path="contacts" element={<AdminContacts/>}/>
          <Route path="stats" element={<AdminStats/>}/>
          <Route path="leads" element={<AdminLeads/>}/>
          <Route path="newsletter-envoi" element={<AdminNewsletterSend/>}/>
          <Route path="emails" element={<AdminEmails/>}/>
          <Route path="pages" element={<AdminPages/>}/>
          <Route path="testimonials" element={<AdminTestimonials/>}/>
          <Route path="social" element={<AdminSocial/>}/>
          <Route path="settings" element={<AdminSettings/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
